import LevelSelectorScene from '../scenes/LevelSelector';
import BaseScene from '../scenes/BaseScene';

export default class Level extends Phaser.GameObjects.Sprite {
    private relatedScene: BaseScene;
    private levelId: number;
    private maxLevelFinished: number;
    private status: string;

    constructor(scene: BaseScene, x: number, y: number, levelId: number) {

        // Game Mode Adjust
        const gameModeOffsetX = scene.getBootloaderScene().globals.gameMode === 'mobile' ? 0 : 370;

        super(scene, x + gameModeOffsetX, y, 'button_level_selector'); 

        this.relatedScene = scene;
        this.levelId = levelId;
        this.maxLevelFinished = (this.relatedScene as LevelSelectorScene).maxLevelFinished;
        this.status = this.getStatusLevel();
        this.enterRestState();
        this.relatedScene.add.existing(this);

        if(this.status != 'locked') {
            // Add text level
            this.relatedScene.add.text(x + gameModeOffsetX, y - 6, levelId.toString())
                .setOrigin(0.5)
                .setStyle({ 
                    fontFamily: 'equestria',
                    fontSize: 46,
                    color: '#fff'
                })
                .setStroke('#212121', 6);

            // Set interactive
            this.setInteractive({ useHandCursor: true })
                .setOrigin(0.5)
                .on('pointerover', () => this.enterHoverState() )
                .on('pointerout', () => this.enterRestState() )
                .on('pointerdown', () => this.enterActiveState() )
                .on('pointerup', () => {
                    this.enterHoverState();
                });
        }    
    }

    public getLevelId(): number {
        return this.levelId;
    } 

    private getStatusLevel(): string {
        if(this.levelId <= this.maxLevelFinished) {
            return 'completed';
        } else if (this.levelId - 1 == this.maxLevelFinished) {
            return 'unlocked';
        } else {
            return 'locked';
        }
    }

    private enterHoverState(): void {
        switch(this.status) {
        case 'completed':
            this.setFrame(4);
            break;
        case 'unlocked':
            this.setFrame(3);
            break;
        case 'locked':
            this.setFrame(2);
            break;
        }
    }
    
    private enterRestState(): void {
        switch(this.status) {
        case 'completed':
            this.setFrame(4);
            break;
        case 'unlocked':
            this.setFrame(5);
            break;
        case 'locked':
            this.setFrame(2);
            break;
        }
    }

    private enterActiveState(): void {
        switch(this.status) {
        case 'completed':
            this.setFrame(0);
            this.relatedScene.scene.pause('LevelSelector');
            this.relatedScene.scene.launch('LevelSelectorInfo', {levelId: this.levelId});
            this.relatedScene.scene.bringToTop('LevelSelectorInfo');
     
            break;
        case 'unlocked':
            this.setFrame(1);
            this.relatedScene.scene.pause('LevelSelector');
            this.relatedScene.scene.launch('LevelSelectorInfo', {levelId: this.levelId});
            this.relatedScene.scene.bringToTop('LevelSelectorInfo');

            break;
        case 'locked':
            this.setFrame(2);
            break;
        }
    }
}